<template>
  <div>
    <div class="user">
      <div class="user-box">
        <div class="photo" v-if="companyAvatar" :style="'background-image: url(' + companyAvatar + ')'" @click.prevent="minimizeSidebar(1)">
        </div>
        <div class="photo" v-else></div>
        <div class="info">
          <a data-toggle="collapse" @click.prevent="goToSettings" href="#">
            <span>{{ companyName }}</span>
          </a>
          <div class="clearfix"></div>
          <div> </div>
        </div>
      </div>

      <div class="modules-preview">
        <div class="progress-header">
          <div class="progress-percentage">
            <span class="percent-value">{{ activeModulesPercent }}%</span>
            <span class="percent-label">{{ $t('general.modulesActivate') }}</span>
          </div>
          <div class="module-icons">
            <div class="icon-item active">
              <img src="../../../../static/img/a.png">
            </div>
          </div>
        </div>

        <!-- Slider -->
        <div class="progress-slider-container">
          <div class="progress-track">
            <div class="progress-fill" :style="{ width: activeModulesPercent + '%' }"></div>
            <div class="progress-thumb" :style="{ left: activeModulesPercent + '%' }"></div>
          </div>
        </div>

        <div class="allModules">
          <a class="goToALLmodules" @click="openModulesModal">{{ $t('pages.allModules') }}</a>
        </div>
      </div>
    </div>

    <!-- Modal component -->
    <AllModulesModal
      ref="allModulesModalRef"
      :active-modules-percent="activeModulesPercent"
      :active-modules="activeModules"
      :inactive-modules="inactiveModules"
    />
  </div>
</template>

<script>
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import AllModulesModal from './AllModulesModal.vue'

export default {
  components: {
    [CollapseTransition.name]: CollapseTransition,
    AllModulesModal
  },
  data () {
    return {
      isClosed: false,
      companyName: this.$session.get('companyName'),
      userData: JSON.parse(this.$session.get('userData') || '{}'),
      companyAvatar: this.$session.get('companyAvatar'),
      modules: [
        { name: this.$t('modules_reservations'), key: 'use_rezerve', image: require('../../../../static/img/reservation-table.png') },
        { name: this.$t('modules_tables'), key: 'use_table', image: require('../../../../static/img/icons/menu-table.png') },
        { name: this.$t('modules_dispatch'), key: 'use_dispatch', image: require('../../../../static/img/dispatch-n.png') },
        { name: this.$t('modules_kds'), key: 'use_kds', image: require('../../../../static/img/Component 2 – 1.png') },
        { name: this.$t('modules_pms'), key: 'use_pms', image: require('../../../../static/img/hotel.png') },
        { name: this.$t('modules_app'), key: 'use_app', image: require('../../../../static/img/app.png') },
        { name: this.$t('modules_website'), key: 'use_website', image: require('../../../../static/img/website.png') },
        { name: this.$t('modules_catalog'), key: 'use_catalog', image: require('../../../../static/img/icons/menu-catalog.png') },
        { name: this.$t('modules_screens'), key: 'use_screens', image: require('../../../../static/img/screen-play.png') },
        { name: this.$t('modules_pos'), key: 'use_pos', image: require('../../../../static/img/point-of-sale-bill.png') },
        { name: this.$t('modules_inventory'), key: 'use_gestiune', image: require('../../../../static/img/icons/menu-gestiune.png') },
        { name: this.$t('modules_clients'), key: 'use_client', image: require('../../../../static/img/Component 4 – 1.png') },
        { name: this.$t('modules_orders'), key: 'use_ordering', image: require('../../../../static/img/Icon awesome-shopping-cart.png') },
        { name: this.$t('modules_add_order'), key: 'use_add_order', image: require('../../../../static/img/Component 5 – 1.png') },
        { name: this.$t('modules_marketing'), key: 'use_marketing_standard', image: require('../../../../static/img/flag.png') },
        { name: this.$t('modules_marketing_gift'), key: 'use_marketing_gift_card', image: require('../../../../static/img/giftcard.png') },
        { name: this.$t('modules_kiosk'), key: 'use_kiosk', image: require('../../../../static/img/menu-kiosk.png') },
        { name: this.$t('modules_qr_ordering'), key: 'use_qr_ordering', image: require('../../../../static/img/qr-scan.png') }
      ]
    }
  },
  created () {
    this.minimizeSidebar()
    // this.getCompany()
    console.log('userData', this.userData.companies)
    this.$on('companyName', function (name) {
      // console.warn('the new name is: ' + name)
      this.companyName = name
    })
  },
  computed: {
    companyFeatures () {
      return this.userData.companies[0] || {}
    },
    enrichedModules () {
      const features = this.companyFeatures || {}
      const DEFAULT_ACTIVE = ['use_rezerve', 'use_catalog', 'use_client', 'use_ordering', 'use_add_order']
      return this.modules.map(module => {
        const hasKey = Object.prototype.hasOwnProperty.call(features, module.key)
        const value = features[module.key]
        const active = DEFAULT_ACTIVE.includes(module.key) ? true : hasKey ? Number(value) === 1 : false
        return { ...module, active }
      })
    },
    activeModules () {
      return this.enrichedModules.filter(m => m.active)
    },
    inactiveModules () {
      return this.enrichedModules.filter(m => !m.active)
    },
    activeModulesPercent () {
      const total = this.enrichedModules.length
      const active = this.enrichedModules.filter(m => m.active).length
      return total ? Math.round((active / total) * 100) : 0
    }
  },
  methods: {
    toggleMenu () {
      this.isClosed = !this.isClosed
    },
    goToSettings () {
      this.$session.set('selecetdTab', 'Company Details')
      if (!this.isOwner()) {
        this.$router.push('/admin/overview')
      } else {
        this.$router.push('/settings')
      }
    },
    minimizeSidebar (isMinimizeFromButton) {
      if (isMinimizeFromButton) {
        this.$sidebar.toggleMinimize()
        this.$session.set('isMinimized', this.$sidebar.isMinimized)
      } else {
        let minMenu = this.$session.get('isMinimized')
        if (minMenu === undefined && this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize()
        }
        if (minMenu === false && this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize()
        } else if (minMenu && !this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize()
        }
      }
    },
    openModulesModal () {
      this.$refs.allModulesModalRef.open()
    }
  }
}
</script>

<style>
.collapsed {
  transition: opacity 1s;
}

.sidebar .user {
  gap: 20px;
}

.allModules a {
  background-color: #0097FC !important;
  border-radius: 15px !important;
  padding: 14px 20px;
  display: block;
  color: #ffff;
  text-align: center;
  margin: 0px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 22px;
}

/* Container principal pentru preview */
.modules-preview {
  padding: 16px 10px 12px;
  margin: 0 10px;
  background: #5420BE;
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-bottom: none;
  width: calc(100% - 10px);
}

/* Header cu procent și iconițe */
.progress-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 4px;
}

.progress-percentage {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.percent-value {
  font-size: 16px;
  font-weight: 600;
  color: #F39E1A;
  line-height: 1;
}

.percent-label {
  font-size: 8px;
  color: #fff;
  font-weight: 400;
}

/* Iconițe module */
.module-icons {
  display: flex;
  gap: 6px;
}

.icon-item {
  border-radius: 8px;
}

.icon-item.inactive {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.4);
}

.icon-item svg {
  width: 18px;
  height: 18px;
}

/* Slider/Progress bar */
.progress-slider-container {
  padding: 0 4px;
}

.progress-track {
  position: relative;
  height: 8px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 999px;
  overflow: visible;
}

.progress-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: linear-gradient(90deg, #ff9500 0%, #ffb700 100%);
  border-radius: 999px;
  box-shadow: 0 0 12px rgba(255, 183, 0, 0.5);
  transition: width 0.3s ease;
}

.progress-thumb {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  background: #ffb700;
  border: 3px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4), 0 0 0 4px rgba(255, 183, 0, 0.2);
  transition: left 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue